export const stripe = state => {
    return state.stripe;
};

export const paymentMethods = state => {
    return state.paymentMethods;
};

export const intentToken = state => {
    return state.intentToken;
};

export const planId = state => {
    return state.planId;
};


// WEBPACK FOOTER //
// ./src/store/modules/api/getters.js